<template>
    <ConsultRecords/>
</template>
<script>
import ConsultRecords from 'place/consultation/consultRecords.vue'
export default {
    components:{
        ConsultRecords
    }
}
</script>